import { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Cookie } from "lucide-react";

const KEY = "fpc-cookie-consent";

export const CookieBanner = () => {
  const [visible, setVisible] = useState(() => !localStorage.getItem(KEY));

  const choose = (value) => {
    localStorage.setItem(KEY, value);
    if (value === "accepted") window.__initAnalytics?.();
    setVisible(false);
  };

  return (
    <AnimatePresence>
      {visible && (
        <motion.div
          data-testid="cookie-banner"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          transition={{ duration: 0.3 }}
          className="fixed inset-0 z-[80] bg-[#181817]/40 backdrop-blur-sm flex items-center justify-center p-4"
        >
          <motion.div
            initial={{ opacity: 0, y: 24, scale: 0.97 }}
            animate={{ opacity: 1, y: 0, scale: 1 }}
            exit={{ opacity: 0, y: 24, scale: 0.97 }}
            transition={{ duration: 0.4, ease: [0.22, 1, 0.36, 1] }}
            className="w-full max-w-lg bg-[#181817] text-[#FBF9F5] rounded-sm shadow-[0_30px_60px_-20px_rgba(24,24,23,0.5)] p-6 sm:p-8"
          >
          <div className="flex items-start gap-4">
            <span className="w-10 h-10 shrink-0 rounded-full bg-[#C85A32] text-[#FBF9F5] flex items-center justify-center">
              <Cookie size={17} />
            </span>
            <div className="min-w-0">
              <p className="text-sm leading-relaxed text-[#FBF9F5]/90">
                Utilizziamo cookie tecnici e, solo con il tuo consenso, analisi anonime di navigazione. Nessun cookie di profilazione.{" "}
                <a data-testid="cookie-privacy-link" href="/privacy" className="underline underline-offset-4 hover:text-white">
                  Privacy & Cookie Policy
                </a>
              </p>
              <div className="mt-4 flex flex-wrap gap-3">
                <button
                  data-testid="cookie-accept-button"
                  onClick={() => choose("accepted")}
                  className="bg-[#FBF9F5] text-[#181817] px-6 py-2.5 rounded-full text-sm hover:bg-[#C85A32] hover:text-[#FBF9F5] transition-colors duration-300"
                >
                  Accetta
                </button>
                <button
                  data-testid="cookie-reject-button"
                  onClick={() => choose("rejected")}
                  className="border border-[#FBF9F5]/30 text-[#FBF9F5]/80 px-6 py-2.5 rounded-full text-sm hover:border-[#FBF9F5] hover:text-[#FBF9F5] transition-colors duration-300"
                >
                  Rifiuta
                </button>
              </div>
            </div>
          </div>
          </motion.div>
        </motion.div>
      )}
    </AnimatePresence>
  );
};
